import { render, staticRenderFns } from "./declaration.vue?vue&type=template&id=d4cd46d0&scoped=true"
import script from "./declaration.vue?vue&type=script&lang=ts"
export * from "./declaration.vue?vue&type=script&lang=ts"
import style0 from "./declaration.vue?vue&type=style&index=0&id=d4cd46d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cd46d0",
  null
  
)

export default component.exports